import type { ColumnDef } from '@tanstack/react-table';
import type { GastoComun } from '@condo/contracts';
import { DataTable } from '@/components/common/data-table';
import { formatClp } from '@/lib/format/currency';
import { formatLongDate, formatPeriodo } from '@/lib/format/date';
import { EstadoBadge } from './estado-badge';

const columns: ColumnDef<GastoComun>[] = [
  {
    accessorKey: 'periodo',
    header: 'Periodo',
    cell: ({ row }) => (
      <span className="font-display text-sm font-semibold">
        {formatPeriodo(row.original.periodo)}
      </span>
    ),
  },
  {
    accessorKey: 'montoTotal',
    header: 'Monto total',
    cell: ({ row }) => (
      <span className="font-display tabular font-semibold">
        {formatClp(row.original.montoTotal)}
      </span>
    ),
  },
  {
    accessorKey: 'fechaVencimiento',
    header: 'Vencimiento',
    cell: ({ row }) => (
      <span className="text-xs text-[var(--color-ink-muted)]">
        {formatLongDate(row.original.fechaVencimiento)}
      </span>
    ),
  },
  {
    accessorKey: 'estado',
    header: 'Estado',
    cell: ({ row }) => <EstadoBadge estado={row.original.estado} />,
  },
];

interface Props {
  data: GastoComun[];
  isLoading?: boolean;
  onRowClick?: (g: GastoComun) => void;
}

export function GastosTable({ data, isLoading, onRowClick }: Props) {
  return (
    <DataTable
      columns={columns}
      data={data}
      isLoading={isLoading}
      onRowClick={onRowClick}
    />
  );
}
